<template>
  <div id="app">
    <Base></Base>
  </div>
</template>

<script>
import { rem, isMobile } from './tools/utils'
import Base from './views/base/base.vue';

export default {
  name: 'App',
  components: {
    Base
  },
  mounted(){
    if (isMobile()) {
      rem(750);
    } else {
      rem(1300);
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
}

.footer {
  position: absolute;
  z-index: 99;
  width: 100%;
  height: 500px;
  top: 100vh;
}
::-webkit-scrollbar {
  width: 0.1rem;
  height: 0.1rem;
  background-color: #ece8d9;
}

::-webkit-scrollbar:hover {
  background-color: #ece8d9;
}

::-webkit-scrollbar-thumb {
  min-height: 0.05rem;
  min-width: 0.05rem;
  -webkit-border-radius: 20px;
  border: 1px solid #f5db7d;
  background-color: #f5db7d;
}

::-webkit-scrollbar-thumb:hover {
  min-height: 0.05rem;
  min-width: 0.05rem;
  -webkit-border-radius: 20px;
  border: 1px solid #f5db7d;
  background-color: #f5db7d;
}

::-webkit-scrollbar-thumb:active {
  -webkit-border-radius: 0.2rem;
  border: 1px solid #f5db7d;
  background-color: #f5db7d;
}
</style>
